import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-map_multi",
  "use": "icon-map_multi-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" id=\"icon-map_multi\">\n<g id=\"icon-map_multi_surface1\">\n<path style=\" stroke:none;fill-rule:nonzero;fill:rgb(0%,0%,0%);fill-opacity:1;\" d=\"M 1 1.027344 C -7 9.144531 6.855469 23 14.972656 15 C 23 7 9 -7 1 1.027344 M 3.601563 2.601563 C 11.253906 -1.863281 19 9.484375 12.398438 13.398438 C 4.746094 17.863281 -3 6.515625 3.601563 2.601563 M 4 7 L 3 8 C 7 12 10 9 13 5 L 12 4 C 9.203125 6 7.378906 7.609375 4 7 \" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/map/map_multi.svg
// module id = V7g2
// module chunks = 24